import { LicenseData } from "@/model/data/License/LicenseData";
import { LicenseModule } from "@/model/data/License/LicenseModule";
import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";

export class GetLicenseDataResData extends ServiceResponseData {
    licenseData: LicenseData;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.status == 200) {
            this.licenseData = this.parse(response.data.LicenseData);
        } else throw response.data.Message;
    }

    parse(data: any): LicenseData {
        const res = new LicenseData();

        res.isHardwareKey = data.IsHardwareKey;
        res.maxDevices = data.MaxDevices;
        res.toUpdateDeviceLicenseExpiration = data.ToUpdateDeviceLicenseExpiration;

        data.OemCodes.forEach((c) => {
            res.oemCodes.push(c);
        });

        if (data.Modules.ServiceAndUpdatesManagement)
            res.modules.push(this.parseLicenseModule(LicenseModuleEnum.ServiceAndUpdatesManagement, data.Modules.ServiceAndUpdatesManagement));
        if (data.Modules.CashFlowManagement) res.modules.push(this.parseLicenseModule(LicenseModuleEnum.CashFlowManagement, data.Modules.CashFlowManagement));
        if (data.Modules.SecurityManagement) res.modules.push(this.parseLicenseModule(LicenseModuleEnum.SecurityManagement, data.Modules.SecurityManagement));
        if (data.Modules.FitnessStatistics) res.modules.push(this.parseLicenseModule(LicenseModuleEnum.FitnessStatistics, data.Modules.FitnessStatistics));
        if (data.Modules.Integration) res.modules.push(this.parseLicenseModule(LicenseModuleEnum.Integration, data.Modules.Integration));
        if (data.Modules.PredictiveMaintenance) res.modules.push(this.parseLicenseModule(LicenseModuleEnum.PredictiveMaintenance, data.Modules.PredictiveMaintenance));
        if (data.Modules.RemoteLink) res.modules.push(this.parseLicenseModule(LicenseModuleEnum.RemoteLink, data.Modules.RemoteLink));
        if (data.Modules.OneTimeCode) res.modules.push(this.parseLicenseModule(LicenseModuleEnum.OneTimeCode, data.Modules.OneTimeCode));
        if (data.Modules.DataFlow) res.modules.push(this.parseLicenseModule(LicenseModuleEnum.DataFlow, data.Modules.DataFlow));

        return res;
    }

    parseLicenseModule(licenseModule: LicenseModuleEnum, data: any): LicenseModule {
        const res = new LicenseModule();
        res.module = licenseModule;
        res.expirationDate = new Date(data.ExpirationDate);
        res.nDevices = data.NDevices;
        res.status = data.Status;
        return res;
    }
}
